<template>
    <div class="menu">
        <h3 class="panel-title">实验分类
          <el-radio-group v-model="radio1" class="rowtab" @change="switc">
              <el-radio-button label="按章节" class="buttontab"></el-radio-button>
              <el-radio-button label="按知识点" class="buttontab"></el-radio-button>
          </el-radio-group>
        </h3>
          <!-- 知识点 -->
          <!-- el-tree方法 -->
        <div class="tree-el">
          <el-tree
              v-loading="loading"
              v-if="ischapter"
              :data="data"
              ref="treez"
              highlight-current
              :default-expanded-keys="[ this.getSubject ]"
              :props="defaultProps"
              node-key="id"
              accordion
              @node-click="handleOpen">
              <span class="custom-tree-node" slot-scope="{ node }">
                <span :title="node.label">{{ node.label }}</span>
              </span>
          </el-tree>
          <!-- 这里是userSubject为null的时候默认展示全部 -->
          <el-tree
              v-loading="loading"
              v-if="ischapter3"
              :data="data3"
              highlight-current
              :props="defaultProps3"
              node-key="id"
              accordion
              @node-click="handleOpen3">
              <span class="custom-tree-node" slot-scope="{ node }">
                <span :title="node.label">{{ node.label }}</span>
              </span>
          </el-tree>
            <!-- 章节 -->
          <el-tree
              v-loading="loading"
              v-if="ischapter2"
              :data="data2"
              ref="treej"
              highlight-current
              node-key="id"
              :default-expanded-keys="[ this.getSubject2 ]"
              :props="defaultProps2"
              accordion
              @node-click="handleOpen2">
              <span class="custom-tree-node" slot-scope="{ node }">
                <span :title="node.label">{{ node.label }}</span>
              </span>
          </el-tree>
        </div>
        <!--编目选择弹出框-->
        <el-dialog
  title="请选择您的学科"
  :visible.sync="boxEx"
  :show-close="false"
  :close-on-press-escape="false"
  :close-on-click-modal="false"
  width="40%"
  center>
  <el-alert
    :title="showSubject"
    type="warning"
    effect="dark">
  </el-alert>
   

  <div style="margin-top: 20px; text-align: left;">
    <el-radio-group v-model="selectSubject" size="small">
      <el-radio label="1" border>初中化学</el-radio>
      <el-radio label="2" border>初中生物</el-radio>
      <el-radio label="3" border>初中物理</el-radio>
      <el-radio label="4" border>高中化学</el-radio>
      <el-radio label="5" border>高中生物</el-radio>
      <el-radio label="6" border>高中物理</el-radio>
    </el-radio-group>
  </div>

    <div style="text-align:center; margin-top:20px">
    <el-button type="primary" @click="setMyFavSubject"  icon="el-icon-circle-check">确 定</el-button>
   
   </div>
   <div style="text-align:right; margin-top:-40px; display: none;">

    <el-popover
    placement="top"
    title="扫码添加企业微信"
    width="200"
    trigger="hover"
    
    >
    <el-image src="https://www.judaoedu.com/templates/green/images/julaishi_white.jpg"></el-image>
    <el-button slot="reference" type="text" icon="el-icon-question" >开通多个学科</el-button>
  </el-popover>
</div>
  
</el-dialog>


    </div>
</template>

<script>
import request from '@/utils/request'
import {saveUserSubejct,getUserInfo} from '@/api/user'
import {treesByStatus, chaptertreesByStatus } from '@/api/trees'
import { getSubejct } from '@/utils/auth'
  export default {
    data(){
        return{
          boxEx:false,
          showSubject: '',
          getType:0,
          getSubject:0,
          getSubject2:0,
          radio1:'',
          loading:false,
          loading2:false,
          ischapter:false,
          ischapter2:false,
          ischapter3:false,
          selectSubject:'1',
          subjectList:['初中化学','初中生物','初中物理','高中化学','高中生物','高中物理'],
          subjectIdList:[100423,100424,100425,100426,100427,100428],
          knowlageIdList:[100191,100192,100193,100194,100195,100196],
          data:[{}],
          data2:[{}],
          data3:[{}],
          defaultProps: {
            children: 'children',
            label: 'chapterName'
          },
          defaultProps2: {
            children: 'children',
            label: 'chapterName'
          },
          defaultProps3: {
            children: 'children',
            label: 'chapterName'
          },
          firstMenu:[],
          secMenu:[],
          eduId:'',
          edutreeid:'',
          information:[],
        }
    },
    created(){
        this.getinfo();
        // this.getsad();
        // this.getMYsubject();
    },
    methods: {
      getsad(){
        alert(document.documentElement.clientWidth)
      },
      getMYsubject(){
          if(getSubejct()==""){
            this.showSubject = "欢迎您进入虚拟仿真实验室,系统检测到您教授的学科中暂时没有理科学科，为了您更好的体验，请先选择您教授的学科。" 
          }else{
            this.showSubject = "欢迎您进入虚拟仿真实验室,检测到您教授了【"+getSubejct()+"】，请您选择一个学科进行体验。" 
          }
      },
      /**
       * 设置用户的独立学科
       */
      setMyFavSubject(){
        this.$confirm(`确定要设置您的科目为【${this.subjectList[parseInt(this.selectSubject)-1]}】?`, '科目选择提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          // 保存数据
          const subjectId = this.subjectIdList[parseInt(this.selectSubject)-1];
          const knowlageId = this.knowlageIdList[parseInt(this.selectSubject)-1];
          const selectName = this.subjectList[parseInt(this.selectSubject)-1];
          // 提交数据
     
        saveUserSubejct({subjectId:subjectId,knowlageId:knowlageId,subjectName:selectName}).then(res=>{
          if(res.code == 200){
            this.$notify({
              message: '学段学科设置成功',
              type: 'success',
              duration: 1500
            })
            this.boxEx = false;
            window.location.reload()
          }else if(res.code == 400){
            this.$notify({
              message: '添加失败稍后重试',
              type: 'error',
              duration: 1500
            })
          }
        })
          
         
        }).catch(() => {
            
        });
      },
      //获取info
      getinfo(){
        getUserInfo().then(res=>{
          //判断是否是教师，如果是教师的话，就需要选择偏好的章节其他学生，管理员，合作伙伴都是不需要选择
          if(res.jwtUser.userType==2){
          if(res.userSubjectK == null){
            this.getSubject = 0
           // this.boxEx = true;
          }else{
            this.getSubject = res.userSubjectK.treeId
          }
          if(res.userSubjectC == null){
            this.getSubject2 = 0
           // this.boxEx = true;
          }else{
            this.getSubject2 = res.userSubjectC.treeId
          }
        }else{
          this.getSubject = 0;
          this.getSubject2 = 0;
         
        }

          if(res.userSubjectK !== null && res.userSubjectC !== null){
              if(res.userSubjectK.type == 0){
                this.radio1 = '按知识点';
                this.ischapter = true;
                this.ischapter2 = false;
                this.getTrees();
              }
          }else if(res.userSubjectK == null && res.userSubjectC == null){
                this.radio1 = '按知识点';
                this.ischapter = false;
                this.ischapter2 = false;
                this.ischapter3 = true;
                this.getTrees3();
          }else if(res.userSubjectK !== null){
                this.radio1 = '按知识点';
                this.ischapter = true;
                this.ischapter2 = false;
                this.getTrees();
          }else if(res.userSubjectC !== null){
                this.radio1 = '按章节';
                this.ischapter = false;
                this.ischapter2 = true;
                this.getChapterTrees();
          }
        })
      },
      //知识点和章节切换
      switc(value){
        if(value == "按知识点"){
            this.ischapter = true;
            this.ischapter2 = false;
            this.ischapter3 = false;
            this.getTrees();
            this.bus.$emit('switc',this.getSubject)
        }else{
            this.ischapter = false;
            this.ischapter2 = true;
            this.ischapter3 = false;
            this.getChapterTrees();
            this.bus.$emit('switc2',this.getSubject2)
        }
      },
      //通过知识点获取
      getTrees(){
          this.loading=true,
          treesByStatus(this.getSubject).then(res=>{
            this.data = res.data;
            this.loading=false
            this.$nextTick(function(){
              this.$refs.treez.setCurrentKey(this.getSubject)
            })
          })
      },
      // userSubject 为null的时候展示
      getTrees3(){
          this.loading=true
          treesByStatus(this.getSubject).then(res=>{
            this.data3 = res.data;
            this.loading=false
          })
      },
      //通过章节获取
      getChapterTrees(){
          this.loading=true,
          chaptertreesByStatus(this.getSubject2).then(res=>{
            this.data2 = res.data
            this.loading=false
            this.$nextTick(function(){
              this.$refs.treej.setCurrentKey(this.getSubject2)
            })
          })
      },
      // 实验分类点击事件
      handleOpen(data,index) {
        this.bus.$emit("ificationA",data)
        this.eduId = index
      },
      handleOpen2(data,index) {
        this.bus.$emit("ificationA2",data)
        this.eduId = index
      },
      handleOpen3(data,index) {
        this.bus.$emit("ificationA3",data)
        this.eduId = index
      },
      // 实验分类关闭事件
      handleClose(key, keyPath) {
      },
      handleClose2(key, keyPath) {
      }
    }
  }
</script>
<style scoped>
    @import '../styles/pad.css';
    @import '../styles/treeStyle.css';
  @media screen and (min-width:1025px) and (max-width:1366px){

  }
  @media screen and (min-width:1366px) and (max-width:1440px){
  }
  @media screen and (min-width:1441px) and (max-width:1600px){
  }
  @media screen and (min-width:1601px) and (max-width:1920px){
  }
  @media screen and (min-width:1921px) and (max-width:2048px){
  }
  @media (min-width:2049px){
  }

   
 /deep/ .el-dialog {
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  margin: 0px !important;
}

/deep/ .el-radio {
    color: #606266;
    cursor: pointer;
    margin-left: 10px;
    margin-bottom: 10px;
}
/deep/ .el-alert__title{
 letter-spacing: 2px;
}
</style>




// WEBPACK FOOTER //
// src/components/myComponents/Menu.vue